import { createFileRoute } from '@tanstack/react-router'

import { OauthCallbackPage } from '../../../components/pages/oauth/oauth-callback-page.tsx'

export const Route = createFileRoute('/oauth/callback')({
  component: OauthCallbackPage,
})
